import React, { useState } from "react";
import Analytics from "../components/Analytics";

const faqList = [
  {
    id: 1,
    question:
      "What is ESG analytics and how does it support sustainability strategies?",
    answer:
      "ESG analytics is the collection, measurement and tracking of environmental, social and governance data to identify a company’s sustainability performance, risks and opportunities. It helps companies in turning sustainability KPIs and data into data-driven decision making and long term value creation.",
  },
  {
    id: 2,
    question:
      "What types of ESG KPIs can be tracked in Updapt’s analytics dashboard?",
    answer:
      "As a SaaS-based solution embedded in data driven reporting and management, ESG KPIs covered in its analytics dashboard would include, but not limited to -",
    paragraphList: [
      "Environmental parameters like carbon emissions, energy, water, waste, materials, and climate risk indicators.",
      "Social parameters like workforce and diversity, health and safety, labour and human rights, community impact and employee engagement and training.",
      "Governance parameters like board composition, ethics and compliance, data security and privacy, executive compensation and disclosures aligned to reporting standards and frameworks.",
    ],
  },
  {
    id: 3,
    question:
      "How does Updapt benchmark ESG performance against peers or standards?",
    answer:
      "Updapt’s approach to ESG performance benchmarking against peer companies is based on publicly disclosed reports and disclosures of industry/sector wise companies. A peer comparison based on ESG parameters material to the organization is generated in a comparison table and specific environmental, social and governance KPIs mapped in customizable dashboards.",
  },
  {
    id: 4,
    question: "Can ESG data be segmented by geography, function, or timeframe?",
    answer:
      "Yes, ESG data can be segmented by geography, organizational functions, and timeframes based on data migrated in the solution. The data can be sliced and diced across various other dimensions and cross-sections for stakeholders to understand the performance at a granular level.",
  },
  {
    id: 5,
    question: "How are insights visualized—charts, scorecards, heatmaps?",
    answer:
      "Insights in Updapt are visualized across dashboards for high level snapshots and drill down options for granular level data through overall ESG metrics, net zero tracking, target setting and monitoring and data governance reports. Charts and graphs can be customized according to various KPIs and chart types like mix pie charts, bar graphs, donut charts, slicers and waterfall charts among others. Heatmaps for risk identification and categorization, facility level carbon emissions and energy across locations, and supply chain ESG risks can be plotted.",
  },
  {
    id: 6,
    question:
      "Does the platform offer predictive ESG analytics or forecasting?",
    answer:
      "Yes, the platform can offer predictive analysis and forecasting for energy consumption, GHG emissions (Scope 1, 2, and 3), water, and waste KPIs. Predictive ESG analytics and forecasting can also be applied across risk and compliance for scenario-based modelling.",
  },
  {
    id: 7,
    question: "Can analytics be customized for industry-specific ESG metrics?",
    answer:
      "The analytics can be customized for industry-specific ESG metrics that would be most applicable and material to the organization’s sector. Updapt’s platform can be configured with industry-specific KPIs, benchmarking, targets and disclosures aligned with applicable standards and frameworks.",
  },
  {
    id: 8,
    question:
      "Can users export ESG analytics data for stakeholder presentations?",
    answer:
      "Yes, users can export ESG analytics data in pdf and ppt formats, and wherever applicable in excel sheets as well. These can be used for stakeholder presentations, reporting and other graphical representation.",
  },
  {
    id: 9,
    question:
      "How does Updapt support tracking of ESG targets and commitments?",
    answer:
      "Updapt supports tracking of ESG targets and commitments through target setting, baseline mapping and commitment mapping to global initiatives, tracking and monitoring of indicators and KPIs through automated data feeds, short-, mid- and long- term goal setting, and alerts and thresholds that can be created across various plans.",
  },
  {
    id: 10,
    question: "What frameworks does the analytics engine align with?",
    answer:
      "Updapt’s analytics engine aligns with global ESG and Sustainability Reporting Frameworks like SASB (Sustainability Accounting Standards Board), BRSR + BRSR Core, United Nations Sustainable Development Goals (UN SDGs), TCFD (Task Force on Climate-related Financial Disclosures), Integrated Reporting (IR) Framework, CDP (Carbon Disclosure Project), DJSI (Dow Jones Sustainability Index), UN Global Compact (UNGC), CSRD / ESRS (EU Corporate Sustainability Reporting Directive & European Sustainability Reporting Standards), GCCA GuidelineGCCA Guidelines, and investment-related principles such as UN PRI (Principles for Responsible Investment), IFC Performance Standards, and SFDR (Sustainable Finance Disclosure Regulation).",
  },
  {
    id: 11,
    question:
      "Can analytics data be integrated with external systems or dashboards?",
    answer:
      "Yes, analytics data can be integrated with external systems and/or dashboards including ERPs, HRMS, IoT devices, PowerBi/Tableu dashboards, and other tools for enabling cross-functional decision making and single source of truth for sustainability and business performance.",
  },
  {
    id: 12,
    question: "How does ESG analytics help with regulatory readiness?",
    answer:
      "ESG analytics in Updapt is mapped to regulatory frameworks aligning with various global regulatory frameworks and requirements. Datapoints are automatically tagged and organized across ESG metrics and mapped to frameworks, standards, principles and regulatory disclosure requirements. Consolidation of data and analytics across ESG KPIs and generation of regulator-ready reports and dashboards enables market readiness.",
  },
];

function AnalyticsContainer() {
  const [whyFeatures] = useState([
    {
      header: "Climate change and transition risks are real",
      desc: "In today's business, analysing and predicting risks associated with climate change and their impact on your bottomline is critical. A dedicated and personalized risk or scenario analysis assists organisations in setting proactive business strategies.",
    },
    {
      header: "Identify your materiality issues and strategize",
      desc: "An organization's performace is upgraded by precisely establishing, tracing and communicating key ESG materiality issues. Tangible results can be noticed by setting key strategies and efficiency targets. Our analysis provides you with the methodology and platform to execute these activities in a procedural way.",
    },
    {
      header: "It's time to rethink and redesign business approach",
      desc: "Stakeholders, regulators and climate activists are demanding enterprises to be more responsible towards the  climate and communities. You need to take actions to reduce your environmental footprint by analysing your business impact. Use our personalized analyses to set climate based targets and gauge the cost and resources needed to acheive it.",
    },
  ]);
  return <Analytics whyFeatures={whyFeatures} faqList={faqList}></Analytics>;
}

export default AnalyticsContainer;
